import { IApplicationState } from '../../types/redux';
import { isDailyrentDesktopHybridExpActive } from '../../utils/experiments';

export const selectIsDesktopListingAvailable = (state: IApplicationState): boolean => {
  return isDailyrentDesktopHybridExpActive(state.experiments);
};
